export default __webpack_public_path__ + "static/media/Zeus-9.e931f54c.pdf";